import { ComponentProps } from "react"
import { cn } from "@/utils/cn"
import { CircleAlert } from "lucide-react"

interface InputProps extends ComponentProps<"input"> {
  label: string
  error?: string | null | undefined
  inputClassName?: string
  endAdornment?: React.ReactNode
}

export function Input({
  label,
  type,
  className,
  error,
  endAdornment,
  required,
  ...props
}: InputProps) {
  return (
    <label
      className={cn(
        "block font-family-gtpressura text-md text-neutral-dark",
        className
      )}
    >
      <p>
        {label}
        {required && " *"}
      </p>
      <div className="mt-3 flex w-full rounded-xs border border-viola-200 bg-neutral-light transition-all duration-300 focus-within:ring-[1px] focus-within:ring-viola-200 focus-within:outline-viola-100">
        <input className="w-full p-4 outline-none" required={required} {...props} />
        {endAdornment && (
          <div className="border-l border-inherit p-4 font-family-gtpressura text-md text-grey-100">
            {endAdornment}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 flex items-center gap-1 text-xs font-light text-alert">
          <CircleAlert size={16} />
          {error}
        </p>
      )}
    </label>
  )
}
